import Vue from 'vue'
import '@/assets/less/init.less'
import 'element-ui/lib/theme-chalk/index.css'
import '/node_modules/cropperjs/dist/cropper.min.css'
import MetaInfo from 'vue-meta-info'
import * as buffer from 'buffer'

if (typeof window.global === 'undefined') {
  window.global = window
}
if (typeof window.Buffer === 'undefined') {
  window.Buffer = buffer.Buffer
}
import {
  Carousel,
  CarouselItem,
  Upload,
  Dialog,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  Slider,
  Select,
  Option,
  Tooltip,
  Checkbox,
  Popover,
  Button,
  Form,
  FormItem
} from "element-ui";
import App from './App.vue'
import router from './router'
import store from './store'

import MessageDialogPlugin from '@/plugins/MessageDialogPlugin'
import Verify from "@/components/VerifyModal/index";
import { getToken } from "@/utils/token";

Vue.config.productionTip = false
Vue.component(Carousel.name, Carousel)
Vue.component(CarouselItem.name, CarouselItem)
Vue.component(Upload.name, Upload)
Vue.component(Dialog.name, Dialog)
Vue.component(Input.name, Input)
Vue.component(InputNumber.name, InputNumber)
Vue.component(Radio.name, Radio)
Vue.component(RadioGroup.name, RadioGroup)
Vue.component(Slider.name, Slider)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(Tooltip.name, Tooltip)
Vue.component(Checkbox.name, Checkbox)
Vue.component(Popover.name, Popover)
Vue.component(Button.name, Button)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)
Vue.use(MetaInfo)

Vue.use(MessageDialogPlugin)
Vue.use(Verify, { router, store })
router.beforeEach((to, from ,next) => {
  if (getToken()) {
    store.dispatch('updateUserInfo').catch(e=> {})
  }
  next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
